import type { EditorState, Transaction } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';

import type { HtmlClassMenuController } from './html-class-plugin.types';
import type { EditorMode, RtPMPlugin } from '../../editor/types';
import { HtmlClassExtension } from '../../extensions/html-class';

export class HtmlClassPlugin implements RtPMPlugin {
  public buttons = {
    toggleHtmlClassMenu: {
      icon: 'code',
      labelTranslationKey: 'wysiwyg.html-class-plugin.label',
      run: (state: EditorState, dispatch: (tr: Transaction) => void, origin: HTMLElement) => {
        const htmlClass = HtmlClassExtension.getCurrentHtmlClass(state);
        this.menuController.open({
          initial: htmlClass,
          apply: value => {
            const result = HtmlClassExtension.apply(state, value, dispatch);
            this.editorView.focus();
            return result;
          },
        });
      },
      isActive: (state: EditorState) =>
        this.menuController.isOpen() || HtmlClassExtension.allHaveAny(state),
      isDisabled: () => !HtmlClassExtension.anyCanHave(this.editorView.state),
    },
  };
  private editorView: EditorView;

  constructor(private menuController: HtmlClassMenuController) {}

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }
}
